module.exports = "test template";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates/tmpl.js
 ** module id = 10
 ** module chunks = 0
 **/